(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["harmony-cart-drawer"]) return;
  try {
    
(() => {
  const drawer = document.getElementById('harmony-cart-drawer');
  if (!drawer || window.HarmonyCart) return;
  const status = drawer.querySelector('[data-hcd-status]');
  const fallback = drawer.querySelector('[data-hcd-fallback]');
  let busy = false;
  let cartChanged = false;
  let opener;
  const setBusy = (value) => {
    busy = value;
    drawer.setAttribute('aria-busy', String(value));
    drawer.querySelectorAll('[data-hcd-step], [data-hcd-remove], [name="checkout"]').forEach(button => { button.disabled = value; });
  };
  const show = () => {
    if (!drawer.open) {
      opener = document.activeElement;
      drawer.showModal();
      document.documentElement.classList.add('hcd-open');
      drawer.querySelector('[data-hcd-close]').focus();
    }
  };
  const sync = async () => {
    const url = new URL(drawer.dataset.cartUrl, location.origin);
    url.searchParams.set('section_id', drawer.dataset.section);
    const response = await fetch(url, { cache: 'no-store' });
    if (!response.ok) throw new Error(drawer.dataset.error);
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const fresh = html.querySelector('[data-hcd-content]');
    const count = html.querySelector('[data-hcd-count]');
    if (!fresh || !count) throw new Error(drawer.dataset.error);
    drawer.querySelector('[data-hcd-content]').replaceWith(fresh);
    drawer.querySelector('[data-hcd-count]').textContent = count.textContent;
    document.querySelectorAll('[data-cart-count]').forEach(node => {
      node.textContent = Number(count.textContent) ? (node.closest('.mobile-cart-link') ? count.textContent : ` (${count.textContent})`) : '';
    });
    fallback.hidden = true;
  };
  const fail = (error) => {
    status.textContent = error.message || drawer.dataset.error;
    fallback.hidden = false;
  };
  const open = async () => {
    show();
    if (busy) return;
    setBusy(true);
    status.textContent = '';
    try { await sync(); } catch (error) { fail(error); } finally { setBusy(false); }
  };
  window.HarmonyCart = { open };
drawer.addEventListener('close', () => {
    document.documentElement.classList.remove('hcd-open');
    if (opener?.isConnected) opener.focus();
    if (cartChanged && location.pathname.replace(/\/$/, '') === drawer.dataset.cartUrl.replace(/\/$/, '')) location.reload();
  });
  drawer.addEventListener('click', async (event) => {
    if (event.target === drawer || event.target.closest('[data-hcd-close]')) { drawer.close(); return; }
    const control = event.target.closest('[data-hcd-step], [data-hcd-remove]');
    if (!control || busy) return;
    const item = control.closest('[data-hcd-key]');
    const quantity = control.hasAttribute('data-hcd-remove') ? 0 : Number(item.dataset.hcdQuantity) + Number(control.dataset.hcdStep);
    const key = item.dataset.hcdKey;
    const step = control.dataset.hcdStep;
    setBusy(true);
    status.textContent = '';
    try {
      let response;
      if(item.dataset.hcdBundle && quantity===0){
        const current=await (await fetch(drawer.dataset.cartUrl+'.js',{cache:'no-store'})).json();
        const updates={};current.items.filter(line=>line.properties?._landing_bundle||line.properties?._landing_gift).forEach(line=>updates[line.key]=0);
        response=await fetch(drawer.dataset.cartUrl+'/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({updates})});
      }else{
        response=await fetch(`${drawer.dataset.changeUrl}.js`, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity})});
      }
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || drawer.dataset.error);
      cartChanged = true;
      await sync();
      const line = Array.from(drawer.querySelectorAll('[data-hcd-key]')).find(node => node.dataset.hcdKey === key);
      setBusy(false);
      (line?.querySelector(`[data-hcd-step="${step}"]`) || drawer.querySelector('[data-hcd-close]')).focus();
    } catch (error) { fail(error); } finally { setBusy(false); }
  });
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.cart-link, .mobile-cart-link');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
    event.preventDefault();
    open();
  });
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!form.matches('.purchase-box')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy) return;
    const body = new FormData(form);
    body.delete('return_to');
    if (!body.get('quantity')) body.set('quantity','1');
    const button = form.querySelector('[type="submit"]');
    const wasDisabled = button?.disabled;
    show();
    setBusy(true);
    status.textContent = '';
    if (button) button.disabled = true;
    try {
      const response = await fetch(`${drawer.dataset.addUrl}.js`, {method:'POST',headers:{'Accept':'application/json'},body});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || drawer.dataset.error);
      cartChanged = true;
      await sync();
    } catch (error) { fail(error); } finally { setBusy(false); if (button) button.disabled = wasDisabled; }
  }, true);
})();

  } catch(e) { console.error(e); }
})();
})();
